import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SpinnerComponent} from '../spinner/spinner.component';

@Component({
	selector: 'app-display-logo',
	templateUrl: './display-logo.component.html',
	styleUrl: './display-logo.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [SpinnerComponent]
})
export class DisplayLogoComponent {
	@Input() logo: string;
	@Input() size = 30;
	@Input() dark = false;
	@Input() loading = false;
}
